import { TFunction } from 'i18next';

/** Known raw keys emitted by NormalizedRegisterImportParser.BuildImportProblems */
const IMPORT_PROBLEM_LABEL_KEYS: Record<string, string> = {
  ImportReviewStatus: 'admin.excelImport.problemLabels.importReviewStatus',
  ReviewIssueCodes: 'admin.excelImport.problemLabels.reviewIssueCodes',
  ReviewIssues: 'admin.excelImport.problemLabels.reviewIssues',
  UnmappedPaymentCodes: 'admin.excelImport.problemLabels.unmappedPaymentCodes',
  DuplicateNameSources: 'admin.excelImport.problemLabels.duplicateNameSources',
  DuplicateCardSources: 'admin.excelImport.problemLabels.duplicateCardSources',
  InactiveConflictSources: 'admin.excelImport.problemLabels.inactiveConflictSources',
  FullNameRaw: 'admin.excelImport.problemLabels.fullNameRaw',
  CommentsRaw: 'admin.excelImport.problemLabels.commentsRaw',
  ContactRaw: 'admin.excelImport.problemLabels.contactRaw',
  AdditionalEmails: 'admin.excelImport.problemLabels.additionalEmails',
  AdditionalCardNumbers: 'admin.excelImport.problemLabels.additionalCardNumbers',
  CardFormatClass: 'admin.excelImport.problemLabels.cardFormatClass',
  CardNumberRaw: 'admin.excelImport.problemLabels.cardNumberRaw',
  ProfessionalIdentityRaw: 'admin.excelImport.problemLabels.professionalIdentityRaw',
  SignatureRaw: 'admin.excelImport.problemLabels.signatureRaw',
  AnnualFeeRaw: 'admin.excelImport.problemLabels.annualFeeRaw',
  AnnualFeeAmountEUR: 'admin.excelImport.problemLabels.annualFeeAmountEur',
  PaidYears: 'admin.excelImport.problemLabels.paidYears',
  Payment2025Status: 'admin.excelImport.problemLabels.payment2025Status',
  SourceSheet: 'admin.excelImport.problemLabels.sourceSheet',
  SourceRow: 'admin.excelImport.problemLabels.sourceRow',
  SourceRecordKey: 'admin.excelImport.problemLabels.sourceRecordKey',
  RecordFingerprint: 'admin.excelImport.problemLabels.recordFingerprint',
  NameMatchKey: 'admin.excelImport.problemLabels.nameMatchKey',
  EnrichmentReviewStatus: 'admin.excelImport.problemLabels.enrichmentReviewStatus',
  EnrichmentConfidence: 'admin.excelImport.problemLabels.enrichmentConfidence',
  EnrichmentAsOf: 'admin.excelImport.problemLabels.enrichmentAsOf',
  EnrichmentSourceURLs: 'admin.excelImport.problemLabels.enrichmentSourceUrls',
  EnrichmentNotes: 'admin.excelImport.problemLabels.enrichmentNotes',
  'administrativeStatus (unmapped raw)': 'admin.excelImport.problemLabels.administrativeStatusUnmapped',
};

/**
 * Formats persisted import-problems text (raw English keys) into localized lines for admin UI.
 */
export function formatImportProblems(raw: string | null | undefined, t: TFunction): string {
  if (!raw?.trim()) return '';

  return raw
    .split('\n')
    .map(line => {
      const trimmed = line.trim();
      if (!trimmed) return '';

      const colonIndex = trimmed.indexOf(':');
      if (colonIndex <= 0) return trimmed;

      const key = trimmed.slice(0, colonIndex).trim();
      const value = trimmed.slice(colonIndex + 1).trim();

      if (key.startsWith('LegacyPaymentCode')) {
        const year = key.replace('LegacyPaymentCode', '');
        return `${t('admin.excelImport.problemLabels.legacyPaymentCode', { year })}: ${value}`;
      }

      const labelKey = IMPORT_PROBLEM_LABEL_KEYS[key];
      if (labelKey) {
        return `${t(labelKey)}: ${value}`;
      }

      return trimmed;
    })
    .filter(Boolean)
    .join('\n');
}
